<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<h2 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Scheda paziente</h2>

<ng-container *ngIf="editing_birthDate">
  <mat-card class="mat-elevation-z5">
    
  <mat-card-content>
    <h2 style="text-align: center; color:red">Modifica data di nascita</h2>
    <hr>
    <mat-list>
      <mat-list-item>
    <strong>Nuova data di nascita:</strong>
    <mat-form-field  style="margin-left: 8px; margin-top: 9px;">
      <input matInput [matDatepicker]="picker" (dateChange)="setBirthDate($event)" placeholder="Formato dd/mm/yyyy">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </mat-list-item>
  </mat-list>
  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center">
    <div style="text-align: center; margin-top: 20px">
      <button mat-raised-button type="submit" color="primary" (click)="setNewBirthDate()">Inserisci</button>
    </div>
    <div style="text-align: center; margin-top: 20px; margin-left: 10px;">
      <button mat-raised-button type="submit" color="warn" (click)="closeSetNewBirthDate()">Chiudi</button>
  </div>
  </div>


</mat-card-content>
  </mat-card>
</ng-container>

<mat-card class="mat-elevation-z5">
    <mat-card-content>
      <h2 style="text-align: center">Dati anagrafici</h2>
      <hr>
      <mat-list>
        <mat-list-item><strong>Nome:</strong>&nbsp;&nbsp;{{patient.name}}</mat-list-item>
        <mat-list-item><strong>Cognome:</strong>&nbsp;&nbsp;{{patient.surname}}</mat-list-item>
        <mat-list-item><strong>Codice fiscale:</strong>&nbsp;&nbsp;{{patient.ssn}}</mat-list-item>
        <mat-list-item><strong>Data di nascita:</strong>&nbsp;&nbsp;{{patient.birthDate}} 
          <span class="material-icons" style="cursor: pointer" matTooltip="Modifica data di nascita" (click)="modify_birthDate()"> edit </span>
        </mat-list-item>
        <mat-list-item><strong>Luogo di nascita:</strong>&nbsp;&nbsp;{{patient.birthPlace}}</mat-list-item>
        <mat-list-item><strong>E-mail:</strong>&nbsp;&nbsp;{{patient.email}}</mat-list-item>
        <mat-list-item><strong>Cellulare:</strong>&nbsp;&nbsp;{{patient.phoneNumber}}&nbsp;&nbsp;
          <a href="tel:{{patient.phoneNumber}}">
            <span class="material-icons" style="vertical-align: middle">call</span>
          </a>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
  <br>
  <mat-card class="mat-elevation-z5" style="padding-bottom: 20px">
    <mat-card-content>
      <div style="display: flow-root; text-align: center; align-items: center">
        <h2>Dati clinici</h2>
        <span class="material-icons" style="cursor: pointer" matTooltip="Aggiungi dati" (click)="modify()"> note_add </span>
        <!--<ng-container *ngIf="user.email === 'lia.caterina97@gmail.com'">
          <span class="material-icons" style="cursor: pointer" matTooltip="Aggiungi dati clinici al DB" (click)="loadData()"> note_add </span>
        </ng-container>-->
      </div>
      <ng-container *ngIf="!editing; else edit">
        <hr>
        <!--<div style="text-align: center; margin-top: 20px">
          <button mat-raised-button color="primary" (click)="modify()">Modifica</button>
        </div>-->
        <mat-list>

          <div class = "row">
            <div class = "column">
              <h2 style="text-align: center">{{firstColumnTitle}}</h2><hr>
              <mat-list-item style="padding-top: 30px"><strong>Gruppo:</strong>&nbsp;&nbsp;{{patient.category}}<mat-divider></mat-divider></mat-list-item>
              <mat-list-item><strong>Peso:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.weight}} kg<mat-divider></mat-divider></mat-list-item>
              <mat-list-item><strong>Altezza:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.height}} cm<mat-divider></mat-divider></mat-list-item>
              <mat-list-item><strong>Età:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.age}}<mat-divider></mat-divider></mat-list-item>
              <mat-list-item>
                <strong>Sesso:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.sex}}
                &nbsp;&nbsp;<mat-icon matTooltip="1: Donna - 2: Uomo - 3: Altro"> help_center</mat-icon>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item><strong>Patologia/e:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.pathology}}<mat-divider></mat-divider></mat-list-item>
              <mat-list-item><strong>Data della diagnosi:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.dateOfDiagnosis}}<mat-divider></mat-divider></mat-list-item>
              <mat-list-item><strong>Età alla diagnosi:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.ageOfDiagnosis}}<mat-divider></mat-divider></mat-list-item>
              <mat-list-item>
                <strong>Familiarità:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.familiarity}}
                &nbsp;&nbsp;<mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                <mat-divider></mat-divider>
              </mat-list-item>
              <mat-list-item>
                <strong>Durata della patologia:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.pathologyDuration}}
                &nbsp;&nbsp;<mat-icon matTooltip="Durata in anni dalla diagnosi ad oggi"> help_center</mat-icon>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenTherapies = true"
                                   (closed)="panelOpenTherapies = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Piano terapeutico:</div>&nbsp;&nbsp;
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenTherapies">
                  <ng-container *ngIf="patientBodyStat.bodyStat.therapies && patientBodyStat.bodyStat.therapies.length > 0">
                    <div style="margin-left: 10px">
                      <ng-container *ngFor="let n of patientBodyStat.bodyStat.therapies">
                        <div style="padding-left: 10px; padding-bottom: 10px; font-size: 16px">
                          <span class="material-icons && iconList">fiber_manual_record</span>
                          {{n.date}}: {{n.therapy}}
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenNotes = true"
                                   (closed)="panelOpenNotes = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Note:</div>&nbsp;&nbsp;
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenNotes">
                  <ng-container *ngIf="patientBodyStat.bodyStat.notes && patientBodyStat.bodyStat.notes.length > 0">
                    <div style="margin-left: 10px">
                      <ng-container *ngFor="let n of patientBodyStat.bodyStat.notes">
                        <div style="padding-left: 10px; padding-bottom: 10px; font-size: 16px">
                          <span class="material-icons && iconList">fiber_manual_record</span>
                          {{n}}
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </mat-expansion-panel>
            </div>

            <div class="column">
              <h2 style="text-align: center">{{thirdColumnTitle}}</h2>
              <hr>
              <mat-list-item style="padding-top: 30px">
                <strong style = "width: 90%">Interventi resettivi maggiori:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.interventi}}
                <div style = "width: 10%; padding: 10%">
                  <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                </div>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item style="padding-top: 30px">
                <strong style = "width: 90%">Numero di resezioni:</strong>&nbsp;&nbsp;{{patientBodyStat.bodyStat.numResezioni}}
                <div style = "width: 10%; padding: 10%">
                  <mat-icon matTooltip="indica il numero di resezioni effettuate"> help_center</mat-icon>
                </div>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenStomia = true"
                                   (closed)="panelOpenStomia = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Stomia:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenStomia">
                  <ng-container *ngIf="patientBodyStat.bodyStat.stomia && patientBodyStat.bodyStat.stomia.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.stomia">
                      <div style="padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenTerapia5 = true"
                                   (closed)="panelOpenTerapia5 = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Terapia 5-ASA-OS:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      &nbsp;&nbsp;
                      <mat-icon matTooltip="Mostra grafico" (click)="openDialog(patientBodyStat.bodyStat.therapy5ASAOS, 'Terapia 5-ASA-OS', patientBodyStat.bodyStat.therapies, patientBodyStat.bodyStat.notes)">show_chart</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenTerapia5">
                  <ng-container *ngIf="patientBodyStat.bodyStat.therapy5ASAOS && patientBodyStat.bodyStat.therapy5ASAOS.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.therapy5ASAOS">
                      <div style="padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '1'">
                          La terapia è iniziata il: {{n.dateOfStart}} ed è tutt'ora in corso
                        </ng-container>
                        <ng-container *ngIf="n.done === '0'">
                          La terapia non è mai stata effettuata
                        </ng-container>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '0'">
                          La terapia è stata effettuata e conclusa in passato
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenTerapiaTop = true"
                                   (closed)="panelOpenTerapiaTop = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Terapia topica:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      &nbsp;&nbsp;
                      <mat-icon matTooltip="Mostra grafico" (click)="openDialog(patientBodyStat.bodyStat.therapyTOPICA, 'Terapia Topica', patientBodyStat.bodyStat.therapies, patientBodyStat.bodyStat.notes)">show_chart</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenTerapiaTop">
                  <ng-container *ngIf="patientBodyStat.bodyStat.therapyTOPICA && patientBodyStat.bodyStat.therapyTOPICA.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.therapyTOPICA">
                      <div style="padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '1'">
                          La terapia è iniziata il: {{n.dateOfStart}} ed è tutt'ora in corso
                        </ng-container>
                        <ng-container *ngIf="n.done === '0'">
                          La terapia non è mai stata effettuata
                        </ng-container>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '0'">
                          La terapia è stata effettuata e conclusa in passato
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenTerapiaGcs = true"
                                   (closed)="panelOpenTerapiaGcs = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Terapia GCS-OS:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      &nbsp;&nbsp;
                      <mat-icon matTooltip="Mostra grafico" (click)="openDialog(patientBodyStat.bodyStat.therapyGCSOS, 'Terapia GCS-OS', patientBodyStat.bodyStat.therapies, patientBodyStat.bodyStat.notes)">show_chart</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenTerapiaGcs">
                  <ng-container *ngIf="patientBodyStat.bodyStat.therapyGCSOS && patientBodyStat.bodyStat.therapyGCSOS.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.therapyGCSOS">
                      <div style="padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '1'">
                          La terapia è iniziata il: {{n.dateOfStart}} ed è tutt'ora in corso
                        </ng-container>
                        <ng-container *ngIf="n.done === '0'">
                          La terapia non è mai stata effettuata
                        </ng-container>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '0'">
                          La terapia è stata effettuata e conclusa in passato
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenTerapiaImm = true"
                                   (closed)="panelOpenTerapiaImm = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Terapia imm.:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      &nbsp;&nbsp;
                      <mat-icon matTooltip="Mostra grafico" (click)="openDialog(patientBodyStat.bodyStat.therapyIMM, 'Terapia IMM.',patientBodyStat.bodyStat.therapies, patientBodyStat.bodyStat.notes)">show_chart</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenTerapiaImm">
                  <ng-container *ngIf="patientBodyStat.bodyStat.therapyIMM && patientBodyStat.bodyStat.therapyIMM.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.therapyIMM">
                      <div style="padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '1'">
                          La terapia è iniziata il: {{n.dateOfStart}} ed è tutt'ora in corso
                        </ng-container>
                        <ng-container *ngIf="n.done === '0'">
                          La terapia non è mai stata effettuata
                        </ng-container>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '0'">
                          La terapia è stata effettuata e conclusa in passato
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenTerapiaBio = true"
                                   (closed)="panelOpenTerapiaBio = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>Terapia bio.:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      &nbsp;&nbsp;
                      <mat-icon matTooltip="Mostra grafico" (click)="openDialog(patientBodyStat.bodyStat.therapyBIO, 'Terapia BIO.', patientBodyStat.bodyStat.therapies, patientBodyStat.bodyStat.notes)">show_chart</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenTerapiaBio">
                  <ng-container *ngIf="patientBodyStat.bodyStat.therapyBIO && patientBodyStat.bodyStat.therapyBIO.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.therapyBIO">
                      <div style="padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '1'">
                          La terapia è iniziata il: {{n.dateOfStart}} ed è tutt'ora in corso
                        </ng-container>
                        <ng-container *ngIf="n.done === '0'">
                          La terapia non è mai stata effettuata
                        </ng-container>
                        <ng-container *ngIf="n.done === '1' && n.onGoing === '0'">
                          La terapia è stata effettuata e conclusa in passato
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>

            </div>

            <div class = "column">
              <h2 style="text-align: center">{{secondColumnTitle}}</h2>
              <hr>
              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenStoriche = true"
                                   (closed)="panelOpenStoriche = false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>EIMS Storiche:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenStoriche">
                  <ng-container *ngIf="patientBodyStat.bodyStat.storicheEIMS && patientBodyStat.bodyStat.storicheEIMS.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.storicheEIMS">
                      <div style="padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded] = "false"
                                   (opened)="panelOpenAttive = true"
                                   (closed)="panelOpenAttive= false">
                <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                  <mat-panel-title style="width: 50%">
                    <div>
                      <div>EIMS Attive:</div>&nbsp;&nbsp;
                      <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description style="width: 50%">
                    Mostra tutti i dati inseriti
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div *ngIf="panelOpenAttive">
                  <ng-container *ngIf="patientBodyStat.bodyStat.attiveEIMS && patientBodyStat.bodyStat.attiveEIMS.length > 0">
                    <ng-container *ngFor="let n of patientBodyStat.bodyStat.attiveEIMS">
                      <div style= "padding-bottom: 10px; font-size: 16px">
                        <span class="material-icons && iconList">fiber_manual_record</span>
                        Dato inserito il: {{n.dateInput}}<br>
                        data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-expansion-panel>
              <ng-container *ngIf="isPatientCrohn">
                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenInfiammatorio = true"
                                     (closed)="panelOpenInfiammatorio = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Infiammatorio:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenInfiammatorio">
                    <ng-container *ngIf="patientBodyStat.bodyStat.infiammatorioCD && patientBodyStat.bodyStat.infiammatorioCD.length > 0">
                      <ng-container *ngFor="let n of patientBodyStat.bodyStat.infiammatorioCD">
                        <div style="padding-bottom: 10px; font-size: 16px">
                          <span class="material-icons && iconList">fiber_manual_record</span>
                          Dato inserito il: {{n.dateInput}}<br>
                          data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenStenosante = true"
                                     (closed)="panelOpenStenosante = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Stenosante:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenStenosante">
                    <ng-container *ngIf="patientBodyStat.bodyStat.stenosanteCD && patientBodyStat.bodyStat.stenosanteCD.length > 0">
                      <ng-container *ngFor="let n of patientBodyStat.bodyStat.stenosanteCD">
                        <div style="padding-bottom: 10px; font-size: 16px">
                          <span class="material-icons && iconList">fiber_manual_record</span>
                          Dato inserito il: {{n.dateInput}}<br>
                          data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>


                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenPenetrante = true"
                                     (closed)="panelOpenPenetrante = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Penetrante:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenPenetrante">
                    <ng-container *ngIf="patientBodyStat.bodyStat.penetranteCD && patientBodyStat.bodyStat.penetranteCD.length > 0">
                      <ng-container *ngFor="let n of patientBodyStat.bodyStat.penetranteCD">
                        <div style="padding-bottom: 10px; font-size: 16px">
                          <span class="material-icons && iconList">fiber_manual_record</span>
                          Dato inserito il: {{n.dateInput}}<br>
                          data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>


                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenMalPeri = true"
                                     (closed)="panelOpenMalPeri = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Malattia Perianale:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenMalPeri">
                    <ng-container *ngIf="patientBodyStat.bodyStat.malattiaPerianaleCD && patientBodyStat.bodyStat.malattiaPerianaleCD.length > 0">
                      <ng-container *ngFor="let n of patientBodyStat.bodyStat.malattiaPerianaleCD">
                          <div style="padding-bottom: 10px; font-size: 16px">
                            <span class="material-icons && iconList">fiber_manual_record</span>
                            Dato inserito il: {{n.dateInput}}<br>
                            data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                          </div>
                        </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenLocatC = true"
                                     (closed)="panelOpenLocatC = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Locat. Colon:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenLocatC">
                    <ng-container *ngIf="patientBodyStat.bodyStat.locatColonCD && patientBodyStat.bodyStat.locatColonCD.length > 0">
                        <ng-container *ngFor="let n of patientBodyStat.bodyStat.locatColonCD">
                          <div style="padding-bottom: 10px; font-size: 16px">
                            <span class="material-icons && iconList">fiber_manual_record</span>
                            Dato inserito il: {{n.dateInput}}<br>
                            data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                          </div>
                        </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenLocatI = true"
                                     (closed)="panelOpenLocatI = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Locat. Ileum:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenLocatI">
                    <ng-container *ngIf="patientBodyStat.bodyStat.locatIleumCD && patientBodyStat.bodyStat.locatIleumCD.length > 0">
                        <ng-container *ngFor="let n of patientBodyStat.bodyStat.locatIleumCD">
                          <div style="padding-bottom: 10px; font-size: 16px">
                            <span class="material-icons && iconList">fiber_manual_record</span>
                            Dato inserito il: {{n.dateInput}}<br>
                            data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                          </div>
                        </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenLocatGI = true"
                                     (closed)="panelOpenLocatGI = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Locat. Upper GI:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: si - 0: no"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenLocatGI">
                    <ng-container *ngIf="patientBodyStat.bodyStat.locatUpperGI && patientBodyStat.bodyStat.locatUpperGI.length > 0">
                        <ng-container *ngFor="let n of patientBodyStat.bodyStat.locatUpperGI">
                          <div style="padding-bottom: 10px; font-size: 16px">
                            <span class="material-icons && iconList">fiber_manual_record</span>
                            Dato inserito il: {{n.dateInput}}<br>
                            data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                          </div>
                        </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
              </ng-container>

              <ng-container *ngIf="!isPatientCrohn">

                <mat-expansion-panel [expanded] = "false"
                                     (opened)="panelOpenLocatUC = true"
                                     (closed)="panelOpenLocatUC = false">
                  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
                    <mat-panel-title style="width: 50%">
                      <div>
                        <div>Localizzazione UC:</div>&nbsp;&nbsp;
                        <mat-icon matTooltip="1: proctite - 2: colite sinistra - 3: pancolite"> help_center</mat-icon>
                      </div>
                    </mat-panel-title>
                    <mat-panel-description style="width: 50%">
                      Mostra tutti i dati inseriti
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div *ngIf="panelOpenLocatUC">
                    <ng-container *ngIf="patientBodyStat.bodyStat.localizzazioneUC && patientBodyStat.bodyStat.localizzazioneUC.length > 0">
                      <ng-container *ngFor="let n of patientBodyStat.bodyStat.localizzazioneUC">
                          <div style="padding-bottom: 10px; font-size: 16px">
                            <span class="material-icons && iconList">fiber_manual_record</span>
                            Dato inserito il: {{n.dateInput}}<br>
                            data:{{n.date}}&nbsp;&nbsp;valore:{{n.value}}
                          </div>
                        </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </div>

          </div>

        </mat-list>
      </ng-container>

      <ng-template #edit>
        <hr>
        <form class="form" [formGroup]="statForm" (ngSubmit)="onSubmit(statForm.value)">

          <mat-list fxLayout="column wrap">

            <mat-list-item style="background-color: #fffbde"><strong>Gruppo:</strong>&nbsp;&nbsp;{{patient.category}}</mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Peso:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput formControlName="weight" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Altezza:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput formControlName="height" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Età:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput style="cursor: context-menu" formControlName="age" [readonly]="true" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Sesso:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)]="lastSex">
                  <mat-option *ngFor="let value of sexOptions" [value]="value"
                              (onSelectionChange)="selectSexOptions($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>


            <mat-list-item style="background-color: #fffbde">
              <strong>Patologia/e:&nbsp;&nbsp;</strong>
              <mat-form-field style="padding-top: 9px">
                <mat-select required [(value)]="patientBodyStat.bodyStat.pathology">
                  <mat-option *ngFor="let value of pathologies" [value]="value"
                              (onSelectionChange)="selectResult($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>&nbsp;&nbsp;<!--
              <ng-container *ngIf="otherPathology">
                <mat-form-field style="padding-top: 9px">
                  <input matInput formControlName="pathology" (focusin)="notFocused=false" (focusout)="notFocused=true">
                </mat-form-field>
              </ng-container>-->
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Data della diagnosi:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput [matDatepicker]="picker" (dateChange)="setDate($event)" placeholder="{{patientBodyStat.bodyStat.dateOfDiagnosis}}">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Età alla diagnosi:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput style="cursor: context-menu" [readonly]="true" formControlName="ageOfDiagnosis" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Familiarità:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastFamiliarity">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectFamiliarity($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde; min-height: 100px; padding-top: 20px">
              <strong>Durata della patologia:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input style="cursor: context-menu" matInput [readonly]="true" formControlName="pathologyDuration"
                       (focusin)="notFocused=false" (focusout)="notFocused=true">
              </mat-form-field>
              <mat-icon matTooltip="Durata in anni dalla diagnosi ad oggi"> help_center</mat-icon>
            </mat-list-item>
            <!--            solo per CD-->
            <ng-container *ngIf="isPatientCrohn">
              <!--INFIAMMATORIO-->
             <mat-list-item style="background-color: #fff7bd">
               <ng-container>
                 <strong>Infiammatorio:</strong>
                 <mat-form-field style="margin-left: 8px; margin-top: 9px">
                 <mat-select required [(value)] = "lastInfiammatorio">
                   <mat-option *ngFor="let value of options" [value]="value"
                               (onSelectionChange)="selectInfiammatorio($event, value)">
                     {{value}}
                   </mat-option>
                 </mat-select>
                 </mat-form-field>
               </ng-container>
             </mat-list-item>
              <ng-container *ngIf="infiammatorioYes">
                  <mat-list-item style="background-color: #fff7bd">
                    <mat-checkbox [checked]="isDiagnosiDateCheckedInfiammatorio" (change) = "selectDateOfDiagnosisInfiammatorio($event)">Data diagnosi</mat-checkbox>
                  </mat-list-item>
                 <mat-list-item style="background-color: #fff7bd">
                   <mat-checkbox [checked]="isAltraDataCheckedInfiammatorio" (change) = "selectOtherDateInfiammatorio($event)">Altra data</mat-checkbox>
                 </mat-list-item>
              </ng-container>
            <mat-list-item style="background-color: #fff7bd">
              <ng-container *ngIf="isAltraDataCheckedInfiammatorio">
                <mat-form-field>
                  <input matInput (dateChange)="selectDatePickerInfiammatorio($event)" [matDatepicker]="picker" placeholder="{{altraDataInf}}">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </ng-container>
            </mat-list-item>
              <!--STENOSANTE-->
              <mat-list-item style="background-color: #fffbde">
                <strong>Stenosante:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <mat-select required [(value)] = "lastStenosante">
                    <mat-option *ngFor="let value of options" [value]="value"
                                (onSelectionChange)="selectStenosante($event, value)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
              <ng-container *ngIf="stenosanteYes">
                  <mat-list-item style="background-color: #fffbde">
                    <mat-checkbox [checked]="isDiagnosiDateCheckedStenosante" (change) = "selectDateOfDiagnosisStenosante($event)">Data diagnosi</mat-checkbox>
                  </mat-list-item>
                  <mat-list-item style="background-color: #fffbde">
                    <mat-checkbox [checked]="isAltraDataCheckedStenosante" (change) = "selectOtherDateStenosante($event)">Altra data</mat-checkbox>
                  </mat-list-item>
              </ng-container>
              <mat-list-item style="background-color: #fffbde">
                <ng-container *ngIf="isAltraDataCheckedStenosante">
                  <mat-form-field>
                    <input matInput (dateChange)="selectDatePickerStenosante($event)" [matDatepicker]="picker" placeholder="{{altraDataSte}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </mat-list-item>
              <!--PENETRANTE-->
              <mat-list-item style="background-color: #fff7bd">
                <strong>Penetrante:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <mat-select required [(value)] = "lastPenentrante">
                    <mat-option *ngFor="let value of options" [value]="value"
                                (onSelectionChange)="selectPenetrante($event, value)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
             <ng-container *ngIf="penetranteYes">
                  <mat-list-item style="background-color: #fff7bd">
                    <mat-checkbox [checked]="isDiagnosiDateCheckedPenetrante" (change) = "selectDateOfDiagnosisPenetrante($event)">Data diagnosi</mat-checkbox>
                  </mat-list-item>
                  <mat-list-item style="background-color: #fff7bd">
                    <mat-checkbox [checked]="isAltraDataCheckedPenetrante" (change) = "selectOtherDatePenetrante($event)">Altra data</mat-checkbox>
                  </mat-list-item>
             </ng-container>
              <mat-list-item style="background-color: #fff7bd">
                <ng-container *ngIf="isAltraDataCheckedPenetrante">
                  <mat-form-field>
                    <input matInput (dateChange)="selectDatePickerPenetrante($event)" [matDatepicker]="picker" placeholder="{{altraDataPen}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </mat-list-item>
              <!--MALATTIA PERIANALE-->
              <mat-list-item style="background-color: #fffbde">
                <strong>Malattia Perianale:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <mat-select required [(value)] = "lastMalattiaPeri">
                    <mat-option *ngFor="let value of options" [value]="value"
                                (onSelectionChange)="selectMalattiaPerianale($event, value)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
             <ng-container *ngIf="malperiYes">
                  <mat-list-item style="background-color: #fffbde">
                    <mat-checkbox [checked]="isDiagnosiDateCheckedMalPeri" (change) = "selectDateOfDiagnosisMalPeri($event)">Data diagnosi</mat-checkbox>
                  </mat-list-item>
                  <mat-list-item style="background-color: #fffbde">
                    <mat-checkbox [checked]="isAltraDataCheckedMalPeri" (change) = "selectOtherDateMalPeri($event)">Altra data</mat-checkbox>
                  </mat-list-item>
             </ng-container>
              <mat-list-item style="background-color: #fffbde">
                <ng-container *ngIf="isAltraDataCheckedMalPeri">
                  <mat-form-field>
                    <input matInput (dateChange)="selectDatePickerMalPeri($event)" [matDatepicker]="picker" placeholder="{{altraDataMalPeri}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </mat-list-item>
              <!--LOCAT COLON-->
              <mat-list-item style="background-color: #fff7bd">
                <strong>Locat. Colon:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <mat-select required [(value)] = "lastLocatC">
                    <mat-option *ngFor="let value of options" [value]="value"
                                (onSelectionChange)="selectLocatColon($event, value)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
             <ng-container *ngIf="locatColonYes">
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isDiagnosiDateCheckedLocatColon" (change) = "selectDateOfDiagnosisLocatColon($event)">Data diagnosi</mat-checkbox>
                </mat-list-item>
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isAltraDataCheckedLocatColon" (change) = "selectOtherDateLocatColon($event)">Altra data</mat-checkbox>
                </mat-list-item>
             </ng-container>
              <mat-list-item style="background-color: #fff7bd">
                <ng-container *ngIf="isAltraDataCheckedLocatColon">
                  <mat-form-field>
                    <input matInput (dateChange)="selectDatePickerLocatColon($event)" [matDatepicker]="picker" placeholder="{{altraDataLocatColon}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </mat-list-item>
              <!--LOCAT ILEUM-->
              <mat-list-item style="background-color: #fffbde">
                <strong>Locat. Ileum:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <mat-select required [(value)] = "lastLocatI">
                    <mat-option *ngFor="let value of options" [value]="value"
                                (onSelectionChange)="selectLocalIleum($event, value)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
              <ng-container *ngIf="locatIleumYes">
                <mat-list-item style="background-color: #fffbde">
                  <mat-checkbox [checked]="isDiagnosiDateCheckedLocatIleum" (change) = "selectDateOfDiagnosisLocatIleum($event)">Data diagnosi</mat-checkbox>
                </mat-list-item>
                <mat-list-item style="background-color: #fffbde">
                  <mat-checkbox [checked]="isAltraDataCheckedLocatIleum" (change) = "selectOtherDateLocatIleum($event)">Altra data</mat-checkbox>
                </mat-list-item>
              </ng-container>
              <mat-list-item style="background-color: #fffbde">
                <ng-container *ngIf="isAltraDataCheckedLocatIleum">
                  <mat-form-field>
                    <input matInput (dateChange)="selectDatePickerLocatIleum($event)" [matDatepicker]="picker" placeholder="{{altraDataLocatIleum}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </mat-list-item>
              <!--LOCAT UPPER-->
              <mat-list-item style="background-color: #fff7bd">
                <strong>Locat. Upper GI:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <mat-select required [(value)] = "lastLocatUpperGI">
                    <mat-option *ngFor="let value of options" [value]="value"
                                (onSelectionChange)="selectUpperGI($event, value)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
              <ng-container *ngIf="locatUpperYes">
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isDiagnosiDateCheckedLocatUpper" (change) = "selectDateOfDiagnosisLocatUpper($event)">Data diagnosi</mat-checkbox>
                </mat-list-item>
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isAltraDataCheckedLocatUpper" (change) = "selectOtherDateLocatUpper($event)">Altra data</mat-checkbox>
                </mat-list-item>
              </ng-container>
              <mat-list-item style="background-color: #fff7bd">
                <ng-container *ngIf="isAltraDataCheckedLocatUpper">
                  <mat-form-field>
                    <input matInput (dateChange)="selectDatePickerLocatUpper($event)" [matDatepicker]="picker" placeholder="{{altraDataLocatUpper}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </mat-list-item>
            </ng-container>
            <!--            solo per UC e Altro-->
            <ng-container *ngIf="!isPatientCrohn">
              <!--LOCALIZZAZIONE UC-->
              <mat-list-item style="background-color: #fff7bd">
                <strong>Localizzazione UC:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <mat-select required [(value)] = "lastLocalizzazioneUC">
                    <mat-option *ngFor="let value of localization" [value]="value"
                                (onSelectionChange)="selectLocalizzazioneUC($event, value)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isDiagnosiDateCheckedLocUC" (change) = "selectDateOfDiagnosisLocUC($event)">Data diagnosi</mat-checkbox>
                </mat-list-item>
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isAltraDataCheckedLocUC" (change) = "selectOtherDateLocUC($event)">Altra data</mat-checkbox>
                </mat-list-item>
              <mat-list-item style="background-color: #fff7bd">
                <ng-container *ngIf="isAltraDataCheckedLocUC">
                  <mat-form-field>
                    <input matInput (dateChange)="selectDatePickerLocUC($event)" [matDatepicker]="picker" placeholder="{{altraDataLocUC}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </mat-list-item>
            </ng-container>
            <!--STORICHE-->
            <mat-list-item style="background-color: #fffbde">
              <strong>EIMS storiche:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastEIMSstoriche">
                  <mat-option *ngFor="let value of storiche" [value]="value"
                              (onSelectionChange)="selectStoricalEIMS($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <ng-container *ngIf="storicheYes">
                <mat-list-item style="background-color: #fffbde">
                  <mat-checkbox [checked]="isDiagnosiDateCheckedStoriche" (change) = "selectDateOfDiagnosisStoriche($event)">Data diagnosi</mat-checkbox>
                </mat-list-item>
                <mat-list-item style="background-color: #fffbde">
                  <mat-checkbox [checked]="isAltraDataCheckedStoriche" (change) = "selectOtherDateStoriche($event)">Altra data</mat-checkbox>
                </mat-list-item>
            </ng-container>
            <mat-list-item style="background-color: #fffbde">
              <ng-container *ngIf="isAltraDataCheckedStoriche">
                <mat-form-field>
                  <input matInput (dateChange)="selectDatePickerStoriche($event)" [matDatepicker]="picker" placeholder="{{altraDataStoriche}}">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </ng-container>
            </mat-list-item>

            <mat-list-item style="background-color: #fff7bd">
              <strong>EIMS attive:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastEIMSAttive">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectAttiveEIMS($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <ng-container *ngIf="attiveYes">
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isDiagnosiDateCheckedAttive" (change) = "selectDateOfDiagnosisAttive($event)">Data diagnosi</mat-checkbox>
                </mat-list-item>
                <mat-list-item style="background-color: #fff7bd">
                  <mat-checkbox [checked]="isAltraDataCheckedAttive" (change) = "selectOtherDateAttive($event)">Altra data</mat-checkbox>
                </mat-list-item>
            </ng-container>
            <mat-list-item style="background-color: #fff7bd">
              <ng-container *ngIf="isAltraDataCheckedAttive">
                <mat-form-field>
                  <input matInput (dateChange)="selectDatePickerAttive($event)" [matDatepicker]="picker" placeholder="{{altraDataAttive}}">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </ng-container>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde">
              <strong>Interventi:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)]="lastInterventi">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectInterventi($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fff7bd; min-height: 100px; padding-top: 20px">
              <strong>Numero di resezioni:</strong>
                <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <input matInput formControlName="numResezioni" (focusin)="notFocused=false" (focusout)="notFocused=true">
                </mat-form-field>
            </mat-list-item>

            <mat-list-item style="background-color: #fffbde;">
              <strong>Stomia:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastStomia">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectStomia($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <ng-container *ngIf="stomiaYes">
              <mat-list-item style="background-color: #fffbde">
                <mat-checkbox [checked]="isDiagnosiDateCheckedStomia" (change) = "selectDateOfDiagnosisStomia($event)">Data diagnosi</mat-checkbox>
              </mat-list-item>
              <mat-list-item style="background-color: #fffbde">
                <mat-checkbox [checked]="isAltraDataCheckedStomia" (change) = "selectOtherDateStomia($event)">Altra data</mat-checkbox>
              </mat-list-item>
            </ng-container>
            <mat-list-item style="background-color: #fffbde">
              <ng-container *ngIf="isAltraDataCheckedStomia">
                <mat-form-field>
                  <input matInput (dateChange)="selectDatePickerStomia($event)" [matDatepicker]="picker" placeholder="{{altraDataStomia}}">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </ng-container>
            </mat-list-item>

            <div style="display: flow-root; text-align: center; align-items: center">
              <h2>Terapie</h2>
            </div>
<!--            TERAPIA 5 ASA OS-->
            <mat-list-item style="background-color: #fffbde;  min-height: 100px; padding-top: 30px">
              <strong>L'utente ha mai effettuato la Terapia 5-ASA-OS?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "last5ASAOSpast">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectFiveASAOSpast($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item >
            <mat-list-item *ngIf="fiveASAOSpast" style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <strong>La terapia 5-ASA-OS è ancora in corso?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "last5ASAOSpresent">
                  <mat-option *ngFor="let value of options" [value]="value"
                                (onSelectionChange)="selectFiveASAOSpresent($event, value)">
                      {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item *ngIf="fiveASAOSpresent" style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                  <input matInput (dateChange)="selectDate5ASA($event)" [matDatepicker]="picker" placeholder = "{{lastDateOfStart5ASA}}">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </mat-list-item>

            <!--<mat-list-item>
              <strong>Terapia 5-ASA-OS:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastTerapia5ASA">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectFiveASAOS($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>-->

            <mat-list-item style="background-color: #fff7bd; min-height: 100px; padding-top: 30px">
              <strong>L'utente ha mai effettuato la Terapia GCS-OS?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastGCSOSpast">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectGCSpast($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item >
            <mat-list-item *ngIf="gcsPast" style="background-color: #fff7bd; min-height: 100px; padding-top: 30px">
              <strong>La terapia GCS-OS è ancora in corso?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastGCSOSpresent">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectGCSpresent($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item *ngIf="gcsPresent" style="background-color: #fff7bd; min-height: 100px; padding-top: 30px">
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput (dateChange)="selectDateGCS($event)" [matDatepicker]="picker" placeholder = "{{lastDateOfStartGCS}}">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </mat-list-item>

            <!--<mat-list-item>
              <strong>Terapia topica:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastTopica">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectTopica($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>-->

            <mat-list-item style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <strong>L'utente ha mai effettuato la Terapia topica?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastTOPICApast">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectTopicapast($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item >
            <mat-list-item *ngIf="topicaPast" style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <strong>La terapia topica è ancora in corso?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastTOPICApresent">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectTopicapresent($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item *ngIf="topicaPresent" style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput (dateChange)="selectDateTopica($event)" [matDatepicker]="picker" placeholder = "{{lastDateOfStartTOPICA}}">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </mat-list-item>

            <!--<mat-list-item>
              <strong>Terapia GCS-OS:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastGCS">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectGCSOS($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>-->

            <!--<mat-list-item>
              <strong>Terapia imm.:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastIMM">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectImm($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>-->

            <mat-list-item style="background-color: #fff7bd; min-height: 100px; padding-top: 30px">
              <strong>L'utente ha mai effettuato la Terapia IMM.?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastIMMpast">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectImmpast($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item >
            <mat-list-item *ngIf="immPast" style="background-color: #fff7bd; min-height: 100px; padding-top: 30px">
              <strong>La terapia IMM. è ancora in corso?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastIMMpresent">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectImmpresent($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item *ngIf="immPresent" style="background-color: #fff7bd; min-height: 100px; padding-top: 30px">
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput (dateChange)="selectDateImm($event)" [matDatepicker]="picker" placeholder = "{{lastDateOfStartIMM}}">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </mat-list-item>

            <!--<mat-list-item>
              <strong>Terapia bio:</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastBIO">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectBio($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>-->
            <mat-list-item style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <strong>L'utente ha mai effettuato la Terapia Bio.?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastBIOpast">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectBiopast($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item >
            <mat-list-item *ngIf="bioPast" style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <strong>La terapia Bio. è ancora in corso?</strong>
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <mat-select required [(value)] = "lastBIOpresent">
                  <mat-option *ngFor="let value of options" [value]="value"
                              (onSelectionChange)="selectBiopresent($event, value)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item *ngIf="bioPresent" style="background-color: #fffbde; min-height: 100px; padding-top: 30px">
              <mat-form-field style="margin-left: 8px; margin-top: 9px">
                <input matInput (dateChange)="selectDateBio($event)" [matDatepicker]="picker" placeholder = "{{lastDateOfStartBIO}}">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </mat-list-item>

            <div style="display: flow-root; text-align: center; align-items: center">
              <h2>Annotazioni</h2>
            </div>

            <mat-list-item><strong>Piano terapeutico:</strong>&nbsp;&nbsp;</mat-list-item>
              <div style="margin-left: 10px;">
                <ng-container *ngFor="let n of patientBodyStat.bodyStat.therapies">
                  <div style="padding-left: 10px; padding-right: 100px;padding-bottom: 10px; font-size: 16px">
                    <span class="material-icons && iconList">fiber_manual_record</span>
                    {{n.date}}: {{n.therapy}}
                    <span class="material-icons && delete" matTooltip="Elimina definitivamente" (click)="deleteTherapy(n)">delete</span>
                  </div>
                </ng-container>
                  <mat-form-field style="padding-left: 10px; font-size: 16px; min-width: 200px">
                    <input matInput formControlName="therapies" (focusin)="notFocused=false" (focusout)="notFocused=true">
                  </mat-form-field>
              </div>

            <mat-list-item><strong>Note:</strong>&nbsp;&nbsp;</mat-list-item>
              <div style="margin-left: 10px">
                <ng-container *ngFor="let n of patientBodyStat.bodyStat.notes">
                  <div style="padding-left: 10px;padding-right: 100px; padding-bottom: 10px; font-size: 16px">
                    <span class="material-icons && iconList">fiber_manual_record</span>
                    {{n}}
                    <span class="material-icons && delete" matTooltip="Elimina definitivamente"  (click)="deleteNote(n)">delete</span>
                  </div>
                </ng-container>
                <mat-form-field style="padding-left: 10px; font-size: 16px; min-width: 200px">
                  <input matInput formControlName="notes" (focusin)="notFocused=false" (focusout)="notFocused=true">
                </mat-form-field>
              </div>

          </mat-list>

          <div style="display: flex; flex-direction: row; justify-content: center; align-items: center">
            <div style="text-align: center; margin-top: 20px">
              <button mat-raised-button type="submit" color="primary">
                <!--[disabled]="!editingForm.valid"-->Inserisci</button>
            </div>
            <div style="text-align: center; margin-top: 20px; margin-left: 10px;">
              <button mat-raised-button (click)="annulla()" color="warn">
                <!--[disabled]="!editingForm.valid"-->Annulla</button>
          </div>
          </div>
        </form>
      </ng-template>

      <!--<div class="wrapper">
        <div class="overlay" *ngIf="showSpinner">
          <div class="spinner-wrapper">
            <mat-spinner></mat-spinner>
          </div>
        </div>

        <div class="loaded-content" [class.blurred]="showSpinner">
          <ng-content></ng-content>
        </div>
      </div>-->

    </mat-card-content>
  </mat-card>

<!--<ng-container *ngIf="confirmValue">
  <div class = modal>
    <div class = modal-content>
      <div class="modal-header">
        <h4 class="modal-title">Conferma</h4>
        <button type="button" class="close" aria-label="Close" (click)="indietro()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Sei sicuro di voler inserire i dati? Una volta inseriti non sarà possibile modificarli
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click) = "confirm()">Conferma</button>
        <button type="button" class="btn btn-primary" (click)="indietro()">Indietro</button>
      </div>
    </div>
  </div>
</ng-container>-->

